import * as RadixRadioGroup from '@radix-ui/react-radio-group';

import { cn } from '@/lib/cn';

import { focusRing } from './controlStyles';

export interface RadioOption {
  value: string;
  /** The full label, e.g. "3, meets expectations" — never five unlabelled buttons (§9). */
  label: string;
}

interface Props extends RadixRadioGroup.RadioGroupProps {
  options: RadioOption[];
  /** Names the group for assistive technology; a score scale is a labelled group, not loose radios. */
  label: string;
}

export function RadioGroup({ options, label, className, ...props }: Props) {
  return (
    <RadixRadioGroup.Root aria-label={label} className={cn('flex gap-4', className)} {...props}>
      {options.map((option) => (
        <div key={option.value} className="flex items-center gap-2">
          <RadixRadioGroup.Item
            id={`${label}-${option.value}`}
            value={option.value}
            aria-label={option.label}
            className={cn(
              'flex size-4 items-center justify-center rounded-full border border-rule-control bg-paper',
              'data-[state=checked]:border-accent',
              focusRing,
            )}
          >
            <RadixRadioGroup.Indicator className="size-2 rounded-full bg-accent" />
          </RadixRadioGroup.Item>
          <label htmlFor={`${label}-${option.value}`} className="text-sm text-ink-900">
            {option.label}
          </label>
        </div>
      ))}
    </RadixRadioGroup.Root>
  );
}
